import React from 'react';
import styled from 'styled-components';

export function ErrorText({ text = 'Type error', type }) {
  return (
    <ErrorWrapper id="grid-table-error-text" type={type}>
      <TextWrapper type={type}>{text}</TextWrapper>
    </ErrorWrapper>
  );
}

const ErrorWrapper = styled.div`
  width: 215px;
  margin: 0 auto;
  position: absolute;
  text-align: center;
  z-index: 999;
  border: ${({ type }) => (type === 'warning' ? '1px solid #f0ad4e' : '1px solid #df4141')};
  border-radius: 4px;
  &:after {
    content: '';
    height: 100%;
    width: 100%;
    border-radius: 4px;
    position: absolute;
    top: 0;
    left: 0;
  }
  &:before {
    content: '';
    width: 10px;
    height: 10px;
    transform: rotate(45deg);
    border: ${({ type }) => (type === 'warning' ? '1px solid #f0ad4e' : '1px solid #df4141')};
    background: #fff;
    position: absolute;
    z-index: 998;
    left: 10px;
    top: -5px;
    border-radius: 2px;
  }
`;

const TextWrapper = styled.div`
  width: 100%;
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  position: relative;
  z-index: 998;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  text-align: left;
  color: ${({ type }) => (type === 'warning' ? '#f0ad4e' : '#df4141')};
`;
